import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface Timezones {
  zone_name: string
  zone_id: string
}
export interface TimezoneDataState {
  isLoading: boolean
  loadingError: string | null
  TimezoneDropDownMetadata: Timezones[] | null
  httpStatus: number | null
}
export const initialState: TimezoneDataState = {
  isLoading: true,
  loadingError: null,
  TimezoneDropDownMetadata: null,
  httpStatus: null
}

export const timezoneDataSlice = createSlice({
  name: 'timezoneDataSlice',
  initialState,
  reducers: {
    TimezoneDropDownLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        TimezoneDropDownMetadata: null,
        httpStatus: 0
      }
    },
    TimezoneDropDownUpdateAction: (state, action: PayloadAction<{ data: Timezones[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        TimezoneDropDownMetadata: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    TimezoneDropDownErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        TimezoneDropDownMetadata: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  TimezoneDropDownLoadingAction,
  TimezoneDropDownUpdateAction,
  TimezoneDropDownErrorAction
} = timezoneDataSlice.actions

export default timezoneDataSlice.reducer
